import { regexForm } from 'components/utils/regexForm'
import { validationCNPJ } from 'components/utils/validationsFN'
import formatter from 'utils/formatter'
import * as yup from 'yup'

export const schema = yup
    .object({
        cnpj: yup
            .string()
            .matches(regexForm.cnpj)
            .required()
            .transform(value => formatter.cnpj(value))
            .test({
                name: 'invalid',
                test: value =>
                    !!value && validationCNPJ(value as string)
            }),

        razaoSocial: yup.string().required(),

        uf: yup.string().required(),

        codigo: yup.string().required(),

        categorizacao: yup.string().required(),

        instituicaoPagaTaxa: yup
            .string()
            .when('uf', {
                is: 'RJ',
                then: yup.string().required()
            })
            .nullable(),

        expectativaRegistroContratoDiario: yup
            .string()
            .when('uf', {
                is: 'RJ',
                then: yup.string().required()
            })
            .nullable(),

        dataInicioVigencia: yup
            .mixed<string>()
            .concat(yup.date())
            .transform((valorConvertido, valorOriginal) =>
                valorOriginal === '' ? null : valorConvertido
            )
            .nullable(),

        dataFimVigencia: yup
            .mixed<string>()
            .concat(yup.date())
            .transform((valorConvertido, valorOriginal) =>
                valorOriginal === '' ? null : valorConvertido
            )
            .when(
                'dataInicioVigencia',
                (dataInicioVigencia, currentSchema) => {
                    return dataInicioVigencia
                        ? currentSchema.min(
                            dataInicioVigencia,
                            'A Data Final não pode ser inferior à data inicial'
                        )
                        : currentSchema
                }
            )
            .nullable(),

        cep: yup
            .string()
            .required()
            .min(9, 'Mínimo de 8 caracteres')
            .nullable(),

        ufEndereco: yup
            .string()
            .required('UF é um campo obrigatório')
            .nullable(),

        municipio: yup
            .string()
            .required()
            .nullable(),

        logradouro: yup
            .string()
            .trim()
            .required()
            .nullable(),

        bairro: yup
            .string()
            .trim()
            .required()
            .nullable(),

        complemento: yup
            .string()
            .max(20, 'Máximo de 20 caracteres')
            .nullable(),

        numeroEndereco: yup
            .string()
            .max(5, 'Máximo de 5 caracteres')
            .trim()
            .required('Número é um campo obrigatório')
            .nullable(),

        telefone: yup
            .string()
            .required()
            .transform(value =>
                value ? formatter.contato(value) : null
            )
            .matches(regexForm.contato)
            .nullable(),

        dadosNotaDebito: yup
            .object({
                razaoSocial: yup
                    .string()
                    .trim()
                    .required(
                        'Razão social da Nota de Débito é obrigatória'
                    ),

                cnpj: yup
                    .string()
                    .required('CNPJ da Nota de Débito é obrigatório')
                    .transform(value => formatter.cnpj(value))
                    .test({
                        name: 'invalid-cnpj-nota-debito',
                        message:
                            'CNPJ da Nota de Débito informado é inválido',
                        test: value =>
                            !!value &&
                            validationCNPJ(value as string)
                    }),

                inscricaoEstadual: yup
                    .string()
                    .trim()
                    .nullable(),

                telefone: yup
                    .string()
                    .required(
                        'Telefone da Nota de Débito é obrigatório'
                    )
                    .transform(value =>
                        value ? formatter.contato(value) : null
                    )
                    .matches(
                        regexForm.contato,
                        'Telefone da Nota de Débito informado é inválido'
                    ),

                logradouro: yup
                    .string()
                    .trim()
                    .required(
                        'Logradouro da Nota de Débito é obrigatório'
                    ),

                numeroEndereco: yup
                    .string()
                    .trim()
                    .required(
                        'Número do endereço da Nota de Débito é obrigatório'
                    ),

                complemento: yup
                    .string()
                    .trim()
                    .nullable(),

                bairro: yup
                    .string()
                    .trim()
                    .required(
                        'Bairro da Nota de Débito é obrigatório'
                    ),

                municipio: yup
                    .string()
                    .trim()
                    .required(
                        'Município da Nota de Débito é obrigatório'
                    ),

                codigoMunicipio: yup
                    .string()
                    .trim()
                    .nullable(),

                uf: yup
                    .string()
                    .required(
                        'UF da Nota de Débito é obrigatória'
                    ),

                cep: yup
                    .string()
                    .required(
                        'CEP da Nota de Débito é obrigatório'
                    )
                    .test(
                        'cep-nota-debito-valido',
                        'CEP da Nota de Débito informado é inválido',
                        value => {
                            if (!value) {
                                return false
                            }

                            return (
                                value.replace(/\D/g, '').length === 8
                            )
                        }
                    )
            })
            .required(
                'Dados para emissão da Nota de Débito são obrigatórios'
            )
    })
    .required()